'use client';
import React from 'react';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';

import CartTableRow from './CartTableRow';
import GtmClient from '@/features/gtm/GtmClient';
import { useAuth } from '@/features/authentication/hooks/auth';

const Cart = () => {
  const { user } = useAuth();

  const { items } = useAppSelector((state) => state.cart);
  const total = items.reduce(
    (acc, curr) => acc + curr.price * curr.quantity,
    0
  );
console.log(items);

  return (
    <>
      <GtmClient
        name="view_cart"
        data={{
          member_id: user?.data?.id || null,
          items: items,
          value: total,
          currency: 'BDT',
        }}
      />
      <div className="cart__product">
        {items.length > 0 ? (
          items.map((item, i) => (
            <CartTableRow key={i} product={item} total={total} />
          ))
        ) : (
          <div className="text-center text-muted py-5 border rounded">
            Your cart is empty.
          </div>
        )}

        {/* Cart Footer */}
        {items.length > 0 && (
          <div className="row g-4">
            <div className=" col-12">
              <div className="cart__footer">
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div>
                    <label
                      htmlFor="cart-total"
                      className="form-label fw-medium mb-1"
                    >
                      Cart Total
                    </label>
                    <h5 className="mb-0">৳{total.toFixed(2)}</h5>
                  </div>
                  <Link
                    href="/checkout"
                    className="trk-btn trk-btn--primary trk-btn--lg"
                  >
                    Proceed to checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;
